import { Box, HStack, Text, Image } from "@chakra-ui/react";
import Link from "next/link";
import React from "react";

const Header = () => {
  return (
    <Box
      w="full"
      bg="white"
      position="fixed"
      top={0}
      h="64px"
      justifyContent="space-around"
      alignItems="center"
      display="flex"
    >
      <Link href="/" passHref>
        <Image h="32px" src="/assets/qore-logo.svg" alt="Qore" />
      </Link>
      <HStack>
        <Text textColor="gray.500">Already have an account?</Text>
        <Link href="/auth/login">
          <Box
            as="button"
            height="35px"
            lineHeight="1.2"
            transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
            border="1px"
            px="8px"
            borderRadius="5px"
            fontSize="14px"
            fontWeight="semibold"
            bg="#f5f6f7"
            borderColor="#ccd0d5"
            color="#4b4f56"
            _hover={{ bg: "#ebedf0" }}
            _active={{
              bg: "#dddfe2",
              transform: "scale(0.98)",
              borderColor: "#bec3c9"
            }}
            _focus={{
              boxShadow:
                "0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)"
            }}
          >
            Sign in
          </Box>
        </Link>
      </HStack>
    </Box>
  );
};

export default Header;
